import React from 'react';
import { Link } from 'react-router-dom';


const Logo = ({limage, dimage, slimage, sdimage}) => {
    return (
        <Link to={process.env.PUBLIC_URL + "/"}>
            <img className="light-version-logo softweb-responsive-logo softweb-logo" src={process.env.PUBLIC_URL + limage} alt="logo-light" />
            <img className="dark-version-logo softweb-responsive-logo softweb-logo" src={process.env.PUBLIC_URL + dimage} alt="logo-dark" />
            <img className="sticky-logo sticky-logo-light softweb-responsive-logo" src={process.env.PUBLIC_URL + slimage} alt="logo-sticky-light" />
            <img className="sticky-logo sticky-logo-dark softweb-responsive-logo" src={process.env.PUBLIC_URL + sdimage} alt="logo-sticky-dark" />
        </Link>
    )
}


export default Logo;